import moment from "moment";
import React from "react";
import { formatTimeZone, getTimeZoneFromIana } from "shared/utils/dateTimeUtils";
import { formatTime } from "utilities";

interface Props {
  ianaTimeZoneId: string
}

const LocalTimeRow = ({ ianaTimeZoneId }: Props) => {
  const tz = getTimeZoneFromIana(ianaTimeZoneId, serverReference.culture.uiLocale);
  const localMoment = moment.utc().tz(ianaTimeZoneId);
  return <div>
    <span>{formatTime(localMoment)}</span>
    <div className="text-sublabel">{formatTimeZone(tz)}</div>
  </div>
};

export default LocalTimeRow;